import { useState, useEffect } from 'react';
import { D, st, apiGet, apiPost } from '../constants';

const PLANS = ['trial','solo','crew','team','custom','expired'];
const PLAN_COLORS = {
  trial:   '#f59e0b',
  solo:    '#4da3f5',
  crew:    '#7c4dff',
  team:    '#22c55e',
  custom:  '#f97316',
  expired: '#ef4444',
};

export default function AdminCompanies() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [saving, setSaving]       = useState({});

  useEffect(() => {
    apiGet('/admin/companies').then(d => {
      setCompanies(d.companies || []);
      setLoading(false);
    });
  }, []);

  async function setPlan(id, plan) {
    setSaving(s => ({ ...s, [id]: true }));
    try {
      const res = await apiPost('/admin/companies/' + id + '/plan', { plan });
      setCompanies(prev => prev.map(c => c.id === id ? { ...c, plan: res.plan, planStatus: res.planStatus } : c));
    } finally {
      setSaving(s => ({ ...s, [id]: false }));
    }
  }

  async function setFeature(id, flag, val) {
    setSaving(prev => ({ ...prev, [id]: true }));
    try {
      const cur = companies.find(co => co.id === id);
      const existing = typeof cur?.features === 'string' ? JSON.parse(cur.features || '{}') : (cur?.features || {});
      const updated = { ...existing, [flag]: val };
      await apiPost('/admin/companies/' + id + '/features', { features: updated });
      setCompanies(prev => prev.map(co => co.id === id ? { ...co, features: updated } : co));
    } finally {
      setSaving(prev => ({ ...prev, [id]: false }));
    }
  }

  if (loading) return <div style={{ color: D.muted, padding: 32 }}>Loading...</div>;

  const th = { padding: '8px 12px', color: D.muted, fontWeight: 600, fontSize: 11, textTransform: 'uppercase', textAlign: 'left', borderBottom: '1px solid ' + D.border };
  const td = { padding: '8px 12px', borderBottom: '1px solid ' + D.border, fontSize: 13 };

  return (
    <div>
      <h2 style={{ color: D.accent, marginBottom: 20 }}>Companies</h2>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={th}>Company</th>
              <th style={th}>Email</th>
              <th style={th}>Current Plan</th>
              <th style={th}>AI Bids Used</th>
              <th style={th}>Joined</th>
              <th style={th}>Override Plan</th>
              <th style={th}>Feature Flags</th>
            </tr>
          </thead>
          <tbody>
            {companies.map(c => {
              const color = PLAN_COLORS[c.plan] || D.muted;
              return (
                <tr key={c.id}>
                  <td style={{ ...td, fontWeight: 600 }}>{c.name}{c.isTestAccount ? ' 🧪' : ''}</td>
                  <td style={{ ...td, color: D.muted }}>{c.email}</td>
                  <td style={td}>
                    <span style={{ background: color + '22', color, padding: '2px 10px', borderRadius: 12, fontWeight: 700, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      {c.plan}
                    </span>
                  </td>
                  <td style={{ ...td, color: D.muted }}>
                    {c.aiBidUsed}{c.aiBidBonus > 0 ? ' (+' + c.aiBidBonus + ' bonus)' : ''}
                  </td>
                  <td style={{ ...td, color: D.muted }}>{c.createdAt?.slice(0, 10)}</td>
                  <td style={td}>
                    <select
                      value={c.plan}
                      disabled={!!saving[c.id]}
                      onChange={e => setPlan(c.id, e.target.value)}
                      style={{ background: D.card, color: D.text, border: '1px solid ' + D.border, borderRadius: 6, padding: '4px 8px', fontSize: 12 }}
                    >
                      {PLANS.map(p => <option key={p} value={p}>{p}</option>)}
                    </select>
                    {saving[c.id] && <span style={{ color: D.muted, marginLeft: 8, fontSize: 11 }}>Saving…</span>}
                  </td>
                  <td style={td}>
                    <label style={{display:'flex',alignItems:'center',gap:6,fontSize:12,cursor:'pointer'}}>
                      <input type="checkbox"
                        checked={!!(typeof c.features==='string'?JSON.parse(c.features||'{}'):c.features||{}).led_tools}
                        disabled={!!saving[c.id]}
                        onChange={e=>setFeature(c.id,'led_tools',e.target.checked)}
                      />
                      AV Lighting
                    </label>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
